import { render, staticRenderFns } from "./SignupSalon.vue?vue&type=template&id=5563626e"
import script from "./SignupSalon.vue?vue&type=script&lang=js"
export * from "./SignupSalon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports